import axiosInstance from '../../../api/axiosConfig';
import { AddSite, Site } from '../types/site';

export const getSites = async () => {
    const response = await axiosInstance.get<Site[]>('/site');
    return response?.data;
};

export const createSite = async (site: AddSite) => {
    const response = await axiosInstance.post<Site>('/site', site);
    return response?.data;
};

export const updateSite = async (site: Site) => {
    const response = await axiosInstance.patch<Site>(`/site/${site.id}`, site);
    return response?.data;
}
